import classNames from 'classnames';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React from 'react';

import './SingleToggleButton.scss';

// A button that can be toggled between an active and inactive state and will
// also show hover state. Via the button.className prop the consumer of this
// can pass a class name that will given --selected, --active, and --hovered modifiers
class SingleToggleButton extends React.Component {
  static propTypes = {
    style: PropTypes.string,
    underlineSelected: PropTypes.bool,
    button: PropTypes.shape({
      action: PropTypes.func,
      title: PropTypes.node,
      isSelected: PropTypes.bool,
      isActive: PropTypes.bool,
      className: PropTypes.string,
      onChildFocused: PropTypes.func,
      onChildBlurred: PropTypes.func,
      qaTag: PropTypes.string,
    }),
  };

  state = {
    isHovered: false,
  };

  toggleHover = val => {
    this.setState({
      isHovered: !!val,
    });
  };

  onChildFocused = e => {
    if (this.props.button.onChildFocused) {
      this.props.button.onChildFocused(e);
    }
  };

  onChildBlurred = e => {
    if (this.props.button.onChildBlurred) {
      this.props.button.onChildBlurred(e);
    }
  };

  render() {
    const SingleToggleButtonClasses = classNames('SingleToggleButton__button', {
      ['SingleToggleButton__button--underline']: this.props.underlineSelected,
      ['SingleToggleButton__button--underline--selected']:
        this.props.underlineSelected && this.props.button.isSelected,
      ['SingleToggleButton__button--selected']: this.props.button.isSelected,
      ['SingleToggleButton__button--hovered']: this.state.isHovered,
      ['SingleToggleButton__button--active']: this.props.button.isActive,
    });

    const buttonClasses = classNames({
      [this.props.button.className]: !!this.props.button.className,
      [`${this.props.button.className}--selected`]:
        !!this.props.button.className && this.props.button.isSelected,
      [`${this.props.button.className}--active`]:
        !!this.props.button.className && this.props.button.isActive,
      [`${this.props.button.className}--hovered`]:
        !!this.props.button.className && this.state.isHovered,
    });

    const classes = this.props.button.className ? buttonClasses : SingleToggleButtonClasses;

    const button = (
      <button
        className={classes}
        data-qa={this.props.button.qaTag}
        type='button'
        onClick={() => {
          this.props.button.action();
        }}
        onMouseEnter={() => {
          this.toggleHover(true);
        }}
        onFocus={debounce(this.onChildFocused, 250)}
        onBlur={debounce(this.onChildBlurred, 250)}
        onMouseLeave={() => {
          this.toggleHover(false);
        }}
      >
        {this.props.button.title}
      </button>
    );

    const rootClass = classNames('SingleToggleButton', {
      [`SingleToggleButton--${this.props.style}`]: this.props.style,
    });

    return <div className={rootClass}>{button}</div>;
  }
}

export default SingleToggleButton;
